import React from 'react';
import '../JobsInfrastructure/Infrastructure.css';
import { dashboardUrl } from '../../service/config';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AnalyticsVisualization from '../framework/analyticsVisualization';
import UnderDevelopment from '../../assets/under-construction.svg';
import { useTheme } from "@mui/material/styles";

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

function CustomTabPanel(props: Readonly<TabPanelProps>) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ p: 3 }}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

function a11yProps(index: number) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`
	};
}

function getLocalStorageItem(key: string) {
	const value = localStorage.getItem(key);
	localStorage.setItem(key, value === 'drill-true' ? 'false' : 'true');
}

const JobsInfrastructure = () => {
	const theme= useTheme();
	const colors = theme.palette;
	const [value, setValue] = React.useState(0);

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
	};
	getLocalStorageItem('drill-down-schedules');
	getLocalStorageItem('drill-down-jobs');
	getLocalStorageItem('drill-down-execution');

	return (
		<div className="base-tab-infra">
			<Box sx={{ width: '100%' }}>
				<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
					<Tabs value={value} onChange={handleChange} aria-label="basic tabs example"
						sx={{
								'& .MuiTab-root': {
									...theme.typography.tabLabel,
								textTransform: 'none',
								minHeight: 40,
								borderTopLeftRadius: 4,
								borderTopRightRadius: 4,
								backgroundColor: `${colors.Tab.inActive.bgColor} !important`,
								color: `${colors.Tab.inActive.color} !important`,
								},
								'& .MuiTab-root.Mui-selected': {
								backgroundColor: `${colors.Tab.Active.bgColor} !important`,
								color: `${colors.Tab.Active.color} !important`,
								},
							}}
					>
						<Tab  style={{ float: 'right' }} label="CONTROLM" {...a11yProps(0)} />
						<Tab  style={{ float: 'right' }} label="AUTOSYS" {...a11yProps(1)} />
					</Tabs>
				</Box>
				<CustomTabPanel value={value} index={0}>
					{dashboardUrl.controlMJobsInfrastructure === undefined ? (
						<div style={{ position: 'absolute', left: '45%', top: '50%', color: 'darkgray' }}>
							<img src={UnderDevelopment} alt="under development" />
							<p style={{ position: 'relative', right: '25%', margin: '0' }}>Dashboard under development!</p>
						</div>

					) : (
						<AnalyticsVisualization
							params={{
								dashboardUrl: dashboardUrl.controlMJobsInfrastructure,
								className: 'powerBiIframeContainer',
								otherParams: {
									name: 'PowerBI'
								},
								seamless: true
							}}
						/>
					)}
				</CustomTabPanel>
				<CustomTabPanel value={value} index={1}>
					
					{dashboardUrl.autoSysJobsInfrastructure === undefined ? (
						<div style={{ position: 'absolute', left: '45%', top: '50%', color: 'darkgray' }}>
							<img src={UnderDevelopment} alt='under development' />
							<p style={{ position: 'relative', right: '25%', margin: '0' }}>Dashboard under development!</p>
						</div>

					) : (
						<AnalyticsVisualization
							params={{
								dashboardUrl: dashboardUrl.autoSysJobsInfrastructure,
								className: 'powerBiIframeContainer',
								otherParams: {
									name: 'PowerBI'
								},
								seamless: true
							}}
						/>

					)}
				</CustomTabPanel>
			</Box>
		</div>
	);
};

export default JobsInfrastructure;
